import {
  type AxiosRequestConfig,
  type CreateNewOrderRequestBody,
  type CreateNewOrderResponse,
  httpClient,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';

export const createOrderPartnerFn = async (
  body: CreateNewOrderRequestBody,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.post<CreateNewOrderResponse>(
    apiRoutes.order.createOrderPartner,
    body,
    config
  );
  return response.data;
};
